const portalInterface = {
    updateCartSum: function () {
        if (!window.parent || !window.parent.postMessage)
            return;
        window.parent.postMessage({msg: "dig.eproc.updateCounters"}, "*");
    }
}